// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3oyLz","description":"PatientConsentPreview_description__pSNQ6"};